import { render, staticRenderFns } from "./onebox-managestorageonebox.vue?vue&type=template&id=25bc53b1&"
import script from "./onebox-managestorageonebox.vue?vue&type=script&lang=js&"
export * from "./onebox-managestorageonebox.vue?vue&type=script&lang=js&"
import style0 from "./onebox-managestorageonebox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports